import React, { useEffect } from 'react';
import {
	CardContainer,
	CircularImageWrapper,
	CircularImage,
	NumberCircle,
	DescriptionContainer,
	TitleText,
	DescriptionText,
	DescriptionText2,
	Connector,
	CardWrapper,
	ImageWrapper,
	CardImage,
	ContentSection,
	ModuleCard,
	ModuleHeader,
	ModuleHeaderContent,
	ModuleNumber,
	ModuleIcon,
	ModuleTitle,
	ModuleSubtitle,
	ModuleSubtitle2,
	ModuleBody,
	ModuleImage,
	ModuleOverlay,
	ModuleFooter,
	ModuleFooterLink,
} from './BenchmarkModule.styles';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';

const BenchmarkModule = ({ number, title, imagePath, modulePath }) => {
	const history = useHistory();

	// useEffect(() => {
	// 	const c = document.getElementById('benchmarkModule');
	// 	const ctx = c.getContext('2d');

	// 	if (window.innerWidth <= 1440) {
	// 		ctx.beginPath();
	// 		ctx.moveTo(6, 45);
	// 		ctx.lineTo(25, 30);
	// 		ctx.lineTo(45, 30);
	// 		ctx.strokeStyle = '#393939';
	// 		ctx.lineWidth = 2;
	// 		ctx.stroke();

	// 		ctx.beginPath();
	// 		ctx.arc(6, 45, 5, 0, 2 * Math.PI);
	// 		ctx.fillStyle = '#393939';
	// 		ctx.fill();
	// 	} else if (window.innerWidth <= 1920 && window.innerWidth > 1440) {
	// 		ctx.beginPath();
	// 		ctx.moveTo(6, 25);
	// 		ctx.lineTo(40, 25);
	// 		ctx.lineTo(60, 40);
	// 		ctx.strokeStyle = '#393939';
	// 		ctx.lineWidth = 2;
	// 		ctx.stroke();

	// 		ctx.beginPath();
	// 		ctx.arc(60, 40, 5, 0, 2 * Math.PI);
	// 		ctx.fillStyle = '#393939';
	// 		ctx.fill();
	// 	}
	// }, []);

	const loadModule = path => {
		history.push(path);
	};

	return (
		// <CardContainer>
		// 	<CircularImageWrapper onClick={() => loadModule(modulePath)}>
		// 		<CircularImage className="moduleImage">
		// 			<img src={imagePath} alt="benchmark" />
		// 		</CircularImage>
		// 		<NumberCircle>{number}</NumberCircle>
		// 	</CircularImageWrapper>
		// 	{/* <Connector>
		// 		<canvas id="benchmarkModule" width="100" height="50" />
		// 	</Connector> */}
		// 	<DescriptionContainer>
		// 		<TitleText>{title}</TitleText>
		// 		<DescriptionText>How does spend stack up</DescriptionText>
		// 		<DescriptionText2>against industry peers?</DescriptionText2>
		// 	</DescriptionContainer>
		// </CardContainer>

		// <CardWrapper onClick={() => loadModule(modulePath)}>
		// 	{number && <NumberCircle>{number}</NumberCircle>}
		// 	<CardContainer>
		// 		<ImageWrapper>
		// 			<CardImage>
		// 				<img src={imagePath} alt="benchmark" />
		// 			</CardImage>
		// 		</ImageWrapper>
		// 		<ContentSection>
		// 			<TitleText>{title}</TitleText>
		// 			<DescriptionText>
		// 				How does spend stack up against industry peers?
		// 			</DescriptionText>
		// 		</ContentSection>
		// 	</CardContainer>
		// </CardWrapper>
		<ModuleCard>
			<ModuleHeader>
				<ModuleIcon>
					<span className="icon-analysis" />
				</ModuleIcon>
				<ModuleHeaderContent>
					<ModuleTitle>Benchmark</ModuleTitle>
					<ModuleSubtitle>How does spend stack up </ModuleSubtitle>
					<ModuleSubtitle2>against industry peers?</ModuleSubtitle2>
				</ModuleHeaderContent>
				<ModuleNumber>2</ModuleNumber>
			</ModuleHeader>
			<ModuleBody>
				<ModuleImage src={imagePath} alt="Benchmark" />
				<ModuleOverlay />
			</ModuleBody>
			<ModuleFooter>
				<ModuleFooterLink onClick={() => loadModule(modulePath)}>
					View Details{' '}
					<svg
						width="16"
						height="16"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M13 6L18 12L13 18"
							stroke="currentColor"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
						<path
							d="M6 12H18"
							stroke="currentColor"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				</ModuleFooterLink>
			</ModuleFooter>
		</ModuleCard>
	);
};

export default BenchmarkModule;
